export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'

export const RUN_PAIRING = 'RUN_PAIRING'
export const RUN_PAIRING_SUCCESS = 'RUN_PAIRING_SUCCESS'
export const RUN_PAIRING_FAILURE = 'RUN_PAIRING_FAILURE'

export const CHANGE_TOS_COMPONENT_STATE = 'CHANGE_TOS_COMPONENT_STATE'
